import { useState } from 'react';
import PropTypes from 'prop-types';

// @mui
import { styled, alpha } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment } from '@mui/material';
// component
import Iconify from '../../../components/iconify';
// eslint-disable-next-line
import ListFilter from './ListFilter';
import ListSort from './ListSort';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

SupportListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  getAllHelpRequests: PropTypes.func,
};

export default function SupportListToolbar({ numSelected, filterName, onFilterName,  getAllHelpRequests, }) {
  // eslint-disable-next-line
  const [openFilter, setOpenFilter] = useState(false);
// eslint-disable-next-line
  const handleOpenFilter = () => {
    setOpenFilter(true);
  };
// eslint-disable-next-line 
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };



  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : (
        <div>
        {/* <Tooltip title="Filter list">

         <ListFilter
         <>
              openFilter={openFilter}
              onOpenFilter={handleOpenFilter}
              onCloseFilter={handleCloseFilter}
            />
            </>
        </Tooltip> */}
        <Tooltip title="Sort list">
            <>
            <ListSort  getAllHelpRequests={getAllHelpRequests} />
            </>
        </Tooltip>
       </div>
      )}

    </StyledRoot>
  );
}
